module.exports = __webpack_public_path__ + "pn.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/pn.svg
// module id = 1018
// module chunks = 0